// Re-render a screen when the connection tier changes (TAS-398).
//
// The tier is measured from real downloads, so it moves during the evening —
// a table that starts on the venue wifi and ends on one bar has to stop being
// handed 3 MB films halfway through. A screen that only reads netTier() at
// mount would keep whatever it was told first.

import { useEffect, useState } from 'react';
import { netTier, onNetTierChange } from '@tasted/utils/netTier';

export function useNetTier() {
  const [tier, setTier] = useState(() => netTier());

  useEffect(() => {
    // Between the first render and this effect the tier can already have moved
    // — the observer replays buffered resource timings as soon as it starts.
    setTier(netTier());
    return onNetTierChange(setTier);
  }, []);

  return tier;
}

export default useNetTier;
